export default function AdminDashboard() {
  return (
    <div className="min-h-screen bg-gray-100 p-10">
      
      <h1 className="text-3xl font-bold mb-8">
        Admin Dashboard
      </h1>

      {/* Stats Cards */}
      <div className="grid md:grid-cols-4 gap-6 mb-10">
        
        <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
          <h3 className="text-gray-500">Total Bookings</h3>
          <p className="text-2xl font-bold mt-2">128</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
          <h3 className="text-gray-500">Active Helpers</h3>
          <p className="text-2xl font-bold mt-2">32</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
          <h3 className="text-gray-500">Pending Jobs</h3>
          <p className="text-2xl font-bold mt-2">7</p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
          <h3 className="text-gray-500">Revenue Today</h3>
          <p className="text-2xl font-bold mt-2">₹18,500</p>
        </div>

      </div>

      {/* Recent Bookings Table */}
      <div className="bg-white rounded-xl shadow p-6">
        <h2 className="text-xl font-semibold mb-4">Recent Bookings</h2>

        <table className="w-full text-left">
          <thead>
            <tr className="border-b">
              <th className="py-2">User</th>
              <th className="py-2">Service</th>
              <th className="py-2">Helper</th>
              <th className="py-2">Status</th>
            </tr>
          </thead>

          <tbody>
            <tr className="border-b hover:bg-gray-50">
              <td className="py-2">Rahul</td>
              <td>Plumber</td>
              <td>Amit</td>
              <td className="text-green-600 font-medium">Completed</td>
            </tr>

            <tr className="border-b hover:bg-gray-50">
              <td className="py-2">Priya</td>
              <td>Electrician</td>
              <td>Sohan</td>
              <td className="text-yellow-600 font-medium">Pending</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
}
